import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function base(clientViewId) {
  return `${resolveVendorDirectoryApiBase(clientViewId)}/expansion`;
}

async function parse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || body.message || "Request failed");
    error.status = response.status;
    error.code = body.code || null;
    throw error;
  }
  return body;
}

export async function getExpansionDashboard(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/panel`, { credentials: "include" });
  return parse(response);
}

export async function getExpansionRegistry(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/registro`, { credentials: "include" });
  return parse(response);
}

export async function evaluateExpansionGates(clientViewId, categoryKey) {
  const response = await fetch(`${base(clientViewId)}/categorias/${categoryKey}/puertas/evaluar`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  return parse(response);
}

export async function listExpansionSeedBatches(clientViewId, categoryKey) {
  const query = categoryKey ? `?categoryKey=${encodeURIComponent(categoryKey)}` : "";
  const response = await fetch(`${base(clientViewId)}/lotes${query}`, { credentials: "include" });
  return parse(response);
}

export async function refreshExpansionReadiness(clientViewId) {
  const response = await fetch(`${base(clientViewId)}/preparacion/actualizar`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  return parse(response);
}
